import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { STYLES } from '../consts';
import { UserMessage } from '../../../DesignSystem/LiliUserMessage/UserMessage';
import Spinner, { SpinnerColor } from '../../../generic-components/Spinner';

interface IProps {
    shouldShowSkeleton?: boolean;
}

export const IntroPreLoad = ({ shouldShowSkeleton }: IProps) => (
  !shouldShowSkeleton ? (
    <div className='absolute inset-0 flex items-center justify-center'>
      <UserMessage onClick={() => {}} id='spinnerLoader'>
        <Spinner spinnerColor={SpinnerColor.Blue} height='50px' width='50px' />
      </UserMessage>
    </div>
  ) : (
    <div className={STYLES.INTRO_PRELOAD}>
      <Skeleton width='80px' height='60px' />
      <Skeleton width='300px' height='60px' />
      <Skeleton width='200px' height='60px' />
      <Skeleton width='400px' height='60px' />
    </div>
  )
);
